import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'announcement', en);

const UpdateAnnouncementConfig = {
  settings: {
    layout: { config: {} },
    nav: { title: 'Edit Announcement' },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ANNOUNCEMENT,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/announcement/:id',
      component: React.lazy(() => import('./UpdateAnnouncement')),
    },
  ],
};

export default UpdateAnnouncementConfig;
